import { render, staticRenderFns } from "./PaginacaoComponent.vue?vue&type=template&id=6776da33"
import script from "./PaginacaoComponent.vue?vue&type=script&lang=js"
export * from "./PaginacaoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports